export enum TitlePriceVariant {
  Heading2 = 'heading-2',
  Heading5 = 'heading-5',
  Hint = 'hint',
  BodyLarger = 'body-larger',
  BodyRegular = 'body-regular',
}
